import { DaoService } from "./DaoService";

export class StatutService extends DaoService {
    static CLASS_NAME = 'App\\Models\\Statut';


    static getInstance() {
        return super.getInstance('statut');
    }

    all() {
        return StatutService.get(`${this.prefix}/all`);
    }

    enable(idOrUid) {
        return StatutService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return StatutService.post(`${this.prefix}/${idOrUid}/disable`);
    }

    search(data) {
        return StatutService.post(`${this.prefix}/search`, data);
    }

    updateOrder(statutIds) {
        return StatutService.post(`${this.prefix}/update-order`, {statutIds});
    }

}